import React, { createContext, useContext } from 'react';
import { Editor } from 'tinymce';
import noop from '../../../../../../../lib/doNothing';

type PluginContextProps = {
  editor: Editor | null;
  setModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
  focusEditor: () => any;
};

export const PluginContext = createContext<PluginContextProps>({
  editor: null,
  setModalOpened: noop,
  focusEditor: noop,
});

PluginContext.displayName = 'PluginContext';

export const usePluginContext = () => useContext(PluginContext);
